import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.css';
import api from "./utils/api.js";
Vue.prototype.$api = api; // 将api挂载到vue的原型上复制代码

Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import LongTap from '@/utils/longtap.js';
Vue.use(LongTap);
Vue.directive('longtap', LongTap);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// element-ui message弹窗单例模式
import mainMessage from '@/utils/mainMessage.js';
Vue.prototype.$message = mainMessage;

// import VConsole from 'vconsole'
// if (process.env.VUE_APP_MODE !== 'production') {
	// Vue.use(new VConsole())
// }
Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
